// The DNA/RNA pair a somatic page compares. A page compares one DNA analysis
// with one RNA analysis: the primary pair unless `?partner=<other side's id>`
// picks another. The paired endpoints take the same `partner`; a partner that
// is no longer paired with the analysis (a removed link, an old bookmark)
// answers 400 partner_not_paired, which falls back to the primary pair and
// tells the page to drop the stale id from its URL.

const listeners = new Set()

// usePartner subscribes here; returns the unsubscribe.
export const onPartnerUnpaired = (fn) => {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export const isPartnerNotPaired = (error) =>
  (error?.response?.status ?? error?.status) === 400 &&
  (error?.response?.data?.code ?? error?.data?.code) === 'partner_not_paired'

// Plain objects and URLSearchParams (repeated `gene`) alike.
export const withPartnerParam = (params, partner) => {
  if (!partner) return params
  if (params instanceof URLSearchParams) {
    const next = new URLSearchParams(params)
    next.set('partner', partner)
    return next
  }
  return { ...(params || {}), partner }
}

export const fetchWithPartner = async (fetch, params, partner) => {
  if (!partner) return fetch(params)
  try {
    return await fetch(withPartnerParam(params, partner))
  } catch (error) {
    if (!isPartnerNotPaired(error)) throw error
    listeners.forEach((fn) => fn(String(partner)))
    return fetch(params)
  }
}
